import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { baseUrl } from './helpers'
import App from './App.vue'

import 'normalize.css'
import './assets/css/main.css'

import './assets/js/console-styles.js'
import './assets/js/preload-images.js'
import './assets/js/prevent-draggable.js'

const configFile = baseUrl('/' + import.meta.env.VITE_APP_CONFIG_FILENAME)

fetch(configFile)
  .then((response) => response.json())
  .then((config) => {
    console.debug(`%c[load] ${configFile}`, style.debug)
    window.config = config
    // ---------------------------
    console.info(`%s %c${import.meta.env.PACKAGE_NAME} v${import.meta.env.PACKAGE_VERSION} (${import.meta.env.PACKAGE_BUILD_MODE})`, '🍀', 'color:green; font-style: italic')
    // ---------------------------
    const app = createApp(App)
    app.config.globalProperties.config = config
    app.use(createPinia())
    app.mount('#app')
  })
